import { useCallback } from 'react';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import { useCookiePrefAsync } from '#src/app/shared/hooks/session';
import { isLoaded } from '#src/app/shared/utils/async';

type Result = (isPublic: boolean) => void;

const IN_30_MIN = 1 / 48;

export function useSetPublicSignatureCookie(): Result {
	const {
		data: {
			petition: { id: petitionId },
		},
	} = usePetitionDetailsPageData();
	const { cookies } = useUtilityContext();

	const cookieAllowedState = useCookiePrefAsync('preferences');
	const cookieAllowed = isLoaded(cookieAllowedState) ? cookieAllowedState.value : false;

	return useCallback(
		(isPublic) => {
			if (!isPublic) {
				cookies.remove(`app_meta_public_signature_${petitionId}`);
				return;
			}
			if (cookieAllowed) {
				cookies.set(`app_meta_public_signature_${petitionId}`, 'true', {
					path: '/',
					expires: IN_30_MIN,
				});
			}
		},
		[petitionId, cookies, cookieAllowed],
	);
}
